import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-add\"><defs><style type=\"text/css\"></style></defs><path d=\"M984.5 462.5H561.5V39.5H455v423H32v106.5h423V992h106.5V569H984.5V462.5z\" p-id=\"1496\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol